import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllSetupsJobTypes = async ({
    limit,
    page,
    search,
    status = true,
    use_for = 'dropdown',
    with_than,
    other_than,
    category_uuid,
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);
    const categoryUuids = Array.isArray(category_uuid)
        ? category_uuid
        : category_uuid
          ? [category_uuid]
          : [];
    categoryUuids.forEach((uuid) => {
        if (uuid) queryList.push(`category_uuid[]=${encodeURIComponent(uuid)}`);
    });

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/${
            process.env.REACT_APP_VERSION_API
        }/service/job_type?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
